import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FiHome,
  FiPlusCircle,
  FiPlus,
  FiList,
  FiDollarSign,
  FiFileText,
  FiChevronLeft,
  FiChevronRight,
  FiClipboard,
  FiCalendar,
  FiUser,
  FiBook,
  FiBell,
  FiFile,
  FiAlertTriangle,
  FiMail
} from 'react-icons/fi';
import {
  MdDashboard,
  MdHomeWork,
  MdFormatListBulleted,
  MdCalculate,
  MdPictureAsPdf,
  MdAccountBalance,
  MdAccountBalanceWallet
} from 'react-icons/md';

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState([]);
  const location = useLocation();

  // Auto-expand menus based on active path
  React.useEffect(() => {
    const path = location.pathname;

    // Auto-expand 'dashboard' if we are on dashboard pages
    // if (['/grampanchayatnivaad', '/asthapan-dashboard', '/dashboard2'].includes(path)) {
    //    setExpandedMenus(prev => prev.includes('dashboard') ? prev : [...prev, 'dashboard']);
    // }

    // Check other menus
    menuItems.forEach(item => {
      if (item.hasSubmenu && item.submenu) {
        const isActive = item.submenu.some(subItem => {
          // Simple check: if path matches
          return location.pathname === subItem.path.split('?')[0] &&
            (subItem.path.includes('?') ? location.search.includes(subItem.path.split('?')[1]) : true);
        });
        if (isActive) {
          setExpandedMenus(prev => prev.includes(item.id) ? prev : [...prev, item.id]);
        }
      }
    });
  }, [location.pathname, location.search]);

  // Get current active menu from pathname
  const getActiveMenu = () => {
    const path = location.pathname;
    if (path === '/grampanchayatnivaad' || path === '/') return 'ग्रामपंचायत';
    if (path.startsWith('/asthapan')) return 'अस्थापना';
    if (['/dashboard2'].includes(path) || path.startsWith('/namuna')) return 'ग्रामनिधी';
    if (path.startsWith('/panipuravtha')) return 'पाणीपुरवठा';
    if (path === '/add-property') return 'Add Property';
    if (path === '/property-list') return 'Property List';
    if (path === '/calculate-tax') return 'Calculate Tax';
    if (path === '/print-pdf') return 'Print / PDF';
    return '';
  };

  const activeMenu = getActiveMenu();

  // Government of Maharashtra color scheme
  const colors = {
    primary: '#003366',
    secondary: '#FF9933',
    accent: '#138808',
    light: '#F8FAFC',
    dark: '#1E293B',
    white: '#FFFFFF',
    gray: '#64748B'
  };

  const gradientStyle = {
    background: '#085e53',
  };

  const menuItems = [
    {
      id: 'grampanchayat',
      name: 'ग्रामपंचायत',
      icon: <MdDashboard size={24} />,
      iconSmall: <MdDashboard size={20} />,
      marathi: 'ग्रामपंचायत',
      path: '/grampanchayatnivaad' // Assuming this is the correct path for Grampanchayat selection/dashboard
    },
    {
      id: 'asthapan',
      name: 'अस्थापना',
      icon: <FiHome size={24} />,
      iconSmall: <FiHome size={20} />,
      marathi: 'अस्थापना',
      path: '/asthapan-dashboard'
    },
    {
      id: 'gramniddhi',
      name: 'ग्रामनिधी',
      icon: <MdAccountBalanceWallet size={24} />,
      iconSmall: <MdAccountBalanceWallet size={20} />,
      marathi: 'ग्रामनिधी',
      path: '/dashboard2'
    },
    {
      id: 'panipuravtha',
      name: 'पाणीपुरवठा',
      icon: <FiFileText size={24} />,
      iconSmall: <FiFileText size={20} />,
      marathi: 'पाणीपुरवठा',
      path: '/panipuravtha-dashboard'
    },
     {
  id: 'notices_and_other',
  name: 'नोटीस व इतर',
  icon: <FiBell size={24} />, // changed icon
  iconSmall: <FiBell size={20} />,
  marathi: 'नोटीस व इतर',
  path: '/notices-and-other-dashboard'
},
    {
      id: 'self_declaration',
      name: 'स्वयं-घोषणापत्र',
      icon: <FiClipboard size={24} />,
      iconSmall: <FiClipboard size={20} />,
      marathi: 'स्वयं-घोषणापत्र',
      path: '/self-declaration-dashboard'
    },
    {
      id: 'pdf_namune',
      name: 'PDF नमुने',
      icon: <FiFileText size={24} />,
      iconSmall: <FiFileText size={20} />,
      marathi: 'PDF नमुने',
      path: '/pdf-namune'
    },
    {
      id: 'namuna',
      name: 'नमुना १ ते ३३',
      icon: <MdFormatListBulleted size={24} />,
      iconSmall: <FiList size={20} />,
      marathi: 'नमुना १ ते ३३',
      hasSubmenu: true,
      submenu: [
        { id: 'namuna1', name: 'नमुना १', path: '/namuna1' },
        { id: 'namuna2', name: 'नमुना २', path: '/namuna2' },
        { id: 'namuna3', name: 'नमुना ३', path: '/namuna3' },
        { id: 'namuna4', name: 'नमुना ४', path: '/namuna4' },
        { id: 'namuna5', name: 'नमुना ५', path: '/namuna5' },
        { id: 'namuna6', name: 'नमुना ६', path: '/namuna6' },
        {
          id: 'namuna7',
          name: 'नमुना ७',
          path: '/namuna7',           // fallback / parent path (optional)
          hasSubmenu: true,
          submenu: [
            { id: 'bank-mahiti', name: 'बँक माहिती', path: '/BankMahiti', icon: <MdAccountBalance size={16} /> },
            // { id: 'bank-khate-mahiti', name: 'बँक खाते माहिती', path: '/bank-khate-mahiti', icon: <FiCreditCard size={16} /> },
            { id: 'varshach-shillak-yadi', name: 'वर्षाची शिल्लक यादी', path: '/VarshikShillakForm', icon: <FiCalendar size={16} /> },
            { id: 'jama-karnachya-mahiti', name: 'जमा करणाऱ्याची माहिती', path: '/JamaKarnaryachiMahiti', icon: <FiUser size={16} /> },
            // { id: 'pavti-pustak-mahiti', name: 'पावती पुस्तक माहिती', path: '/pavati-pustak-yadi', icon: <FiBook size={16} /> },
            // { id: 'pavti-pustak-vitaran', name: 'पावती पुस्तक वितरण', path: '/pavati-pustak-vitran-yadi', icon: <FiSend size={16} /> },
            { id: 'checkbook-mahiti', name: 'चेकबुक माहिती', path: '/ChequeBookMahiti', icon: <FiFile size={16} /> },
            { id: 'Banktobanktansfer', name: 'बँकेतून बँकेत पैसे भरणा', path: '/BankToBankTransfer', icon: <MdAccountBalanceWallet size={16} /> }
          ]
        },
        { id: 'namuna8', name: 'नमुना ८', path: '/calculate-tax' },
        {
          id: 'namuna9',
          name: 'नमुना ९',
          path: '/namuna9',           // fallback / parent path (optional)
          hasSubmenu: true,
          submenu: [
            // { id: 'add-namuna9', name: 'नमुना ९ जोडा', path: '/addnamuna9', icon: <FiPlus size={16} /> },
            { id: 'namuna9-list', name: 'नमुना ९ यादी', path: '/namuna9list', icon: <FiList size={16} /> },
            { id: 'magnipavti', name: 'मागणी पावती', path: '/magnipavti', icon: <FiFileText size={16} /> },
            { id: 'japti', name: 'जप्ती', path: '/japti', icon: <FiAlertTriangle size={16} /> },
            { id: 'namuna9-register-rpt', name: 'नमुना ९ रजिस्टर अहवाल', path: '/namuna9register-rpt', icon: <FiBook size={16} /> },
            { id: 'notice-report', name: 'सूचना अहवाल', path: '/notice-report', icon: <FiMail size={16} /> }
          ]
        },
        {
          id: 'namuna10',
          name: 'नमुना १०',
          path: '/Namuna10',
          hasSubmenu: true,
          submenu: [
            { id: 'bank-mahiti', name: 'बँक माहिती', path: '/BankMahiti', icon: <MdAccountBalance size={16} /> },
            // { id: 'bank-khate-mahiti', name: 'बँक खाते माहिती', path: '/bank-khate-mahiti', icon: <FiCreditCard size={16} /> },
            { id: 'varshach-shillak-yadi', name: 'वर्षाची शिल्लक यादी', path: '/VarshikShillakForm', icon: <FiCalendar size={16} /> },
            { id: 'jama-karnachya-mahiti', name: 'जमा करणाऱ्याची माहिती', path: '/JamaKarnaryachiMahiti', icon: <FiUser size={16} /> },
            // { id: 'pavti-pustak-mahiti', name: 'पावती पुस्तक माहिती', path: '/pavati-pustak-yadi', icon: <FiBook size={16} /> },
            // { id: 'pavti-pustak-vitaran', name: 'पावती पुस्तक वितरण', path: '/pavati-pustak-vitran-yadi', icon: <FiSend size={16} /> },
            { id: 'checkbook-mahiti', name: 'चेकबुक माहिती', path: '/ChequeBookMahiti', icon: <FiFile size={16} /> },
            { id: 'Banktobanktansfer', name: 'बँकेतून बँकेत पैसे भरणा', path: '/BankToBankTransfer', icon: <MdAccountBalanceWallet size={16} /> }
          ]
        }
      ]
    },
    // {
    //   id: 'add-property',
    //   name: 'Add Property',
    //   icon: <MdHomeWork size={24} />,
    //   iconSmall: <FiPlusCircle size={20} />,
    //   marathi: 'मालमत्ता जोडा',
    //   path: '/add-property'
    // },
    // {
    //   id: 'property-list',
    //   name: 'Property List',
    //   icon: <MdFormatListBulleted size={24} />,
    //   iconSmall: <FiList size={20} />,
    //   marathi: 'मालमत्ता यादी',
    //   path: '/property-list'
    // },
    // {
    //   id: 'calculate-tax',
    //   name: 'Calculate Tax',
    //   icon: <MdCalculate size={24} />,
    //   iconSmall: <FiDollarSign size={20} />,
    //   marathi: 'कर मोजा',
    //   path: '/calculate-tax'
    // },
    // {
    //   id: 'print-pdf',
    //   name: 'Print / PDF',
    //   icon: <MdPictureAsPdf size={24} />,
    //   iconSmall: <FiFileText size={20} />,
    //   marathi: 'प्रिंट / पीडीएफ',
    //   path: '/print-pdf'
    // }
  ];

  const toggleSubmenu = (menuId) => {
    setExpandedMenus(prev =>
      prev.includes(menuId)
        ? prev.filter(id => id !== menuId)
        : [...prev, menuId]
    );
  };

  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className={`relative ${isCollapsed ? 'w-20' : 'w-64'} transition-all duration-300 ease-in-out`}>
      <div
        className="h-screen shadow-xl sticky top-0 flex flex-col"
        style={gradientStyle}
      >
        {/* Collapse Toggle Button */}
        <button
          onClick={handleCollapse}
          className="absolute -right-3 top-6 bg-white rounded-full p-1 shadow-lg border border-gray-200 hover:shadow-xl transition-shadow duration-200 z-10"
          style={{ color: colors.primary }}
        >
          {isCollapsed ? <FiChevronRight size={20} /> : <FiChevronLeft size={20} />}
        </button>

        {/* User Profile */}
        <div className={`p-4 ${isCollapsed ? 'px-2' : 'px-6'} border-b border-white border-opacity-20`}>
          <div className="flex items-center space-x-3">
            <div className="relative">
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center">
                <span className="font-bold" style={{ color: colors.primary }}>A</span>
              </div>
              <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white"></div>
            </div>
            {!isCollapsed && (
              <div className="text-white">
                <h3 className="font-semibold">आपले स्वागत आहे</h3>
                <p className="text-xs opacity-80">Gram Panchayat Clerk</p>
              </div>
            )}
          </div>
        </div>

        {/* Menu Items */}
        <div className="flex-1 overflow-y-auto py-4">
          <nav className="space-y-1">
            {menuItems.map((item) => (
              <div key={item.id}>
                {item.hasSubmenu ? (
                  <button
                    onClick={() => toggleSubmenu(item.id)}
                    className={`
                      block w-full flex items-center ${isCollapsed ? 'justify-center px-2' : 'px-6'} py-3 
                      text-left transition-all duration-200
                      ${expandedMenus.includes(item.id)
                        ? 'bg-white bg-opacity-20 border-r-4 border-white'
                        : 'hover:bg-white hover:bg-opacity-10'
                      }
                    `}
                  >
                    <div className="flex items-center space-x-3">
                      <div className={`${expandedMenus.includes(item.id) ? 'text-white' : 'text-white text-opacity-80'}`}>
                        {isCollapsed ? item.iconSmall : item.icon}
                      </div>
                      {!isCollapsed && (
                        <>
                          <span className="text-white font-medium">{item.name}</span>
                          <div className="ml-auto">
                            <FiChevronRight
                              size={16}
                              className={`text-white transition-transform duration-200 ${expandedMenus.includes(item.id) ? 'rotate-90' : ''}`}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </button>
                ) : (
                  <Link
                    to={item.path}
                    className={`
                      block w-full flex items-center ${isCollapsed ? 'justify-center px-2' : 'px-6'} py-3 
                      text-left transition-all duration-200
                      ${activeMenu === item.name
                        ? 'bg-white bg-opacity-20 border-r-4 border-white'
                        : 'hover:bg-white hover:bg-opacity-10'
                      }
                    `}
                  >
                    <div className="flex items-center space-x-3">
                      <div className={`${activeMenu === item.name ? 'text-white' : 'text-white text-opacity-80'}`}>
                        {isCollapsed ? item.iconSmall : item.icon}
                      </div>
                      {!isCollapsed && (
                        <span className="text-white font-medium">{item.name}</span>
                      )}
                    </div>
                  </Link>
                )}

                {/* Submenu - Level 1 */}
                {item.hasSubmenu && expandedMenus.includes(item.id) && !isCollapsed && (
                  <div className="bg-white bg-opacity-10">
                    {item.submenu.map((subItem) => (
                      <div key={subItem.id}>
                        {subItem.hasSubmenu ? (
                          <button
                            onClick={() => toggleSubmenu(subItem.id)}
                            className="block w-full flex items-center px-12 py-2 text-left transition-all duration-200 hover:bg-white hover:bg-opacity-10"
                          >
                            <span className="text-white text-sm opacity-90 flex items-center space-x-2">
                              {subItem.icon && <span className="mr-2">{subItem.icon}</span>}
                              {subItem.name}
                            </span>
                            <FiChevronRight
                              size={12}
                              className={`text-white ml-auto transition-transform duration-200 ${expandedMenus.includes(subItem.id) ? 'rotate-90' : ''}`}
                            />
                          </button>
                        ) : (
                          <Link
                            to={subItem.path}
                            className={`block w-full flex items-center px-12 py-2 text-left transition-all duration-200 hover:bg-white hover:bg-opacity-10 ${(location.pathname === subItem.path.split('?')[0] &&
                                (subItem.path.includes('?') ? location.search.includes(subItem.path.split('?')[1]) : true))
                                ? 'bg-white bg-opacity-20 text-white font-medium border-r-4 border-white'
                                : ''
                              }`}
                          >
                            <span className="text-white text-sm opacity-90 flex items-center space-x-2">
                              {subItem.icon && <span className="mr-2">{subItem.icon}</span>}
                              {subItem.name}
                            </span>
                          </Link>
                        )}

                        {/* Nested Submenu - Level 2 */}
                        {subItem.hasSubmenu && expandedMenus.includes(subItem.id) && (
                          <div className="bg-white bg-opacity-5">
                            {subItem.submenu.map((nestedItem) => (
                              <Link
                                key={nestedItem.id}
                                to={nestedItem.path}
                                className="block w-full flex items-center px-16 py-2 text-left transition-all duration-200 hover:bg-white hover:bg-opacity-10"
                              >
                                <span className="text-white text-xs opacity-80 flex items-center space-x-2">
                                  {nestedItem.icon && <span className="mr-2">{nestedItem.icon}</span>}
                                  {nestedItem.name}
                                </span>
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>
        </div>

        {/* Footer sections (active properties, date, etc.) */}
        {!isCollapsed && (
          <>
            <div className="p-4 border-t border-white border-opacity-20">
              <div className="bg-white bg-opacity-10 rounded-lg p-3">
                <div className="flex items-center justify-between text-white text-xs">
                  <div>
                    <p className="font-semibold">Active Properties</p>
                    <p className="text-lg font-bold mt-1">1,248</p>
                  </div>
                  <div className="text-right">
                    <p className="font-semibold">Tax Collected</p>
                    <p className="text-lg font-bold mt-1">₹42.8L</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-4 border-t border-white border-opacity-20">
              <div className="text-center text-white text-xs opacity-75">
                <p>{new Date().toLocaleDateString('en-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</p>
                <p className="mt-1">महाराष्ट्र शासन</p>
              </div>
            </div>
          </>
        )}

        {isCollapsed && (
          <div className="p-2 border-t border-white border-opacity-20">
            <div className="text-center text-white text-xs opacity-75">
              <p>{new Date().getDate()}</p>
              <p className="mt-1">{new Date().toLocaleDateString('en-IN', { month: 'short' })}</p>
            </div>
          </div>
        )}
      </div>

      {/* Collapsed tooltip (optional – you can keep or remove) */}
      {isCollapsed && (
        <div className="fixed left-20 top-0 h-screen flex items-center z-20 pointer-events-none">
          <div className="bg-gray-800 text-white text-sm rounded-r-lg shadow-lg py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-auto">
            {menuItems.map((item) => (
              <Link key={item.id} to={item.path} className="block">
                <div className="px-3 py-2 hover:bg-gray-700 rounded-r">
                  {item.name}
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;